import React, { Component } from "react";

import ExportRecItem from "./RecItem";
import Registry from "../../../Utils/Registry";
import { Button } from "reactstrap";

const EXPORT_TYPE_TITLES = {
    'orders': 'commandes',
    'invoices': "factures",
    'advanced-invoices': "factures detaillées"
}


export default class ExportRecList extends Component {
    static defaultProps = {
        type: "orders",
        onAddClicked: () => {}
    }

    state = {
        list: undefined
    }

    componentDidMount(){
        let user = Registry.observe(this, "user", this.loadList);
        if(user)
            this.loadList(user);
    }

    loadList = user => {
        let api = Registry.registered("api");
        if(user === undefined)
            user = Registry.registered("user");
        if(user){
            if(api) {
                api.get(`/business/${user.business_id}/recurrent_exports?type=${this.props.type}`)
                    .then(r => {
                        this.setState({list: r});
                    });
            }
            else    
                console.error("No API instance");
        }
    };

    render(){
        const { type, onAddClicked } = this.props;
        const { list } = this.state;

        return <div>
            <div className="d-flex justify-content-between align-items-center pad-b-20">
                <h2 className="ty-subtitle marg-b-0">
                    Exports r&eacute;currents des {EXPORT_TYPE_TITLES[type] || "..."}
                </h2>
                <Button className="text-uppercase" size="xs" color="primary" onClick={onAddClicked}>Ajouter</Button>
            </div>

            { 
                list && list.map((r, i) => {
                    return <ExportRecItem 
                        item={r} 
                        key={`rec-${type}-${i}`} 
                        onUpdate={this.loadList}
                    />
                })
            }

            { list && !list.length ? <div className="gray_dark center">Aucun export</div> : null }
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/Operations/Export/RecList.js